import Toastify from 'toastify-js';

const roots = document.querySelectorAll('.has-copy');

roots.forEach(root => {
  const button = root.querySelector('.copy-btn');
  const copyTextElement = root.querySelector('.copy-text');

  if (!button || !copyTextElement) return;

  const text = copyTextElement.textContent.trim();

  button.addEventListener('click', () => {
    navigator.clipboard.writeText(text).then(() => {
      Toastify({
        text: 'Copied to clipboard',
        close: true,
        duration: 3000
      }).showToast();
    });
  });
});
